import MuiChip from "@mui/material/Chip";
import { createTheme, ThemeProvider } from "@mui/material/styles";

interface ChipProps {
    label: string;
    size?: "small" | "medium";
    variant?: "filled" | "outlined";
    icon?: React.ReactElement;
    color?: "warning" | "info" | "success" | "secondary";
}

export const Chip = ({ label, size = "small", variant = "outlined", icon, color }: ChipProps) => {
    const theme = createTheme({
        palette: {
            warning: { main: "#f2b100" },
            info: { main: "#0e86d1" },
            success: { main: "#2e8c00" },
            secondary: { main: "#e4e4e4" },
        },
    });

    return (
        <ThemeProvider theme={theme}>
            <MuiChip label={label} size={size} variant={variant} icon={icon} color={color} />
        </ThemeProvider>
    );
};
